import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { perfPush, perfTraceEnabled } from './perf-trace';

@Injectable()
export class PerfHttpInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!perfTraceEnabled()) {
      return next.handle(req);
    }
    const t0 = performance.now();
    return next.handle(req).pipe(
      tap((event) => {
        if (event instanceof HttpResponse) {
          const path = req.url.replace(/^https?:\/\/[^/]+/, '').split('?')[0];
          const shortPath = path.length > 60 ? path.substring(0, 60) + '…' : path;
          let size = '';
          try {
            const body = (event as HttpResponse<unknown>).body;
            if (body) {
              size = ' ' + Math.round(JSON.stringify(body).length / 1024) + 'KB';
            }
          } catch {
            /* size is best-effort only */
          }
          perfPush(`${req.method} ${shortPath}${size}`, performance.now() - t0);
        }
      }),
    );
  }
}
